import { inject, Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { ToastService } from '@services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivateChild {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly toast = inject(ToastService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    return this.#verificarAcesso(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    return this.#verificarAcesso(route);
  }

  #verificarAcesso(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      const expectedRoles = route.data['roles'] as string[];
      if (expectedRoles && !this.authService.hasAnyRole(expectedRoles)) {
        this.toast.toastErro('Acesso negado', 'Você não tem permissão para realizar esta ação.');
        return false;
      }
      return true;
    }

    void this.router.navigate(['/login']);
    return false;
  }
}
